import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./NotificacionPendientes.css";

const NotificacionPendientes = ({ cantidad, onClose }) => {
  // Cerrar automáticamente después de 10 segundos
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 10000);

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="notificacion-overlay" onClick={onClose}>
      <div className="notificacion-popup" onClick={(e) => e.stopPropagation()}>
        <button className="notificacion-cerrar" onClick={onClose}>
          ×
        </button>
        <div className="notificacion-icono">
          <i className="fas fa-bell"></i>
        </div>
        <h3 className="notificacion-titulo">¡Tienes pendientes por revisar!</h3>
        <p className="notificacion-mensaje">
          Tienes <span className="notificacion-cantidad">{cantidad}</span>{" "}
          {cantidad === 1 ? "pendiente" : "pendientes"} sin completar.
        </p>
        <Link to="/pendientes" className="notificacion-btn" onClick={onClose}>
          Ver mis pendientes
        </Link>
      </div>
    </div>
  );
};

export default NotificacionPendientes;
